import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export default function AboutTeaser() {
  return (
    <section id="about-teaser" className="relative py-24 md:py-28 overflow-hidden" data-testid="about-teaser">
      <div className="glow-orb w-[440px] h-[440px] bg-neon-violet/12 -top-24 -left-16" />
      <div className="container-x relative z-10 grid md:grid-cols-12 gap-10 items-center">
        <Reveal className="md:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-neon-cyan/20 to-neon-violet/20 blur-2xl" />
            <img
              src="/brand/founder.webp"
              alt="Dominique Hilliard, founder of GateMate"
              loading="lazy"
              className="relative z-10 rounded-3xl w-full object-cover object-top aspect-[4/5] border border-white/10"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-7">
          <p className="overline mb-4">Why we're building this</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
            We're all in the same room. <br />
            <span className="text-gradient">We just stopped seeing each other.</span>
          </h2>
          <p className="mt-6 text-lg text-zinc-400 leading-relaxed max-w-xl">
            Concerts, red-eyes, lounges — full of people going somewhere interesting, and completely
            invisible to each other. GateMate is built to fix that.
          </p>
          <Link
            to="/about"
            data-testid="home-about-link"
            className="mt-8 inline-flex items-center gap-2 rounded-full glass hover:glass-cyan px-6 py-3 text-sm font-medium text-white transition-all"
          >
            Read the founder's story <ArrowRight className="w-4 h-4 text-neon-cyan" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
